import {useEffect, useMemo, useState} from 'react';

import {Box, Dropdown} from '@zoom/react-ui';
import {IconTriangleDown, IconTriangleUp} from '@zoom/sun-ui-icon';
import {t} from 'i18next';
import {useTranslation} from 'react-i18next';

import {ZmQuaternaryBtn} from 'Components/ZmButtons';
import {LNG_LIST, LNG_LIST_MAP, LOCAL_STORAGE_KEYS} from 'Utils/consts';

const ZmTranslationSelector = () => {
  const {i18n} = useTranslation();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const webPortalLanguage = localStorage.getItem(LOCAL_STORAGE_KEYS.I18NEXT_LNG) || 'en-US';
    const savedLanguage = localStorage.getItem(LOCAL_STORAGE_KEYS.BOOKING_PAGE_I18NEXT_LNG);
    i18n.changeLanguage(savedLanguage || webPortalLanguage);
  }, [i18n]);

  const items = useMemo(() => LNG_LIST.map((lng) => ({
    key: lng,
    label: LNG_LIST_MAP[lng],
  })), []);

  const handleOnClick = (lng) => {
    i18n.changeLanguage(lng);
    // Temporary key to set the language of the booking page independently from the web
    // Future updates will support synchronizing and modifying the web environment language.
    localStorage.setItem(LOCAL_STORAGE_KEYS.BOOKING_PAGE_I18NEXT_LNG, lng);
  };

  return (
    <Dropdown
      minWidth={150}
      trigger="click"
      items={items}
      selectedKeys={i18n.language || 'en-US'}
      onClick={(e) => {
        handleOnClick(e.key);
      }}
      onClose={() => setOpen(false)}
    >
      <Box>
        <ZmQuaternaryBtn
          aria-label={t('common.selectLanguage')}
          size="xsmall"
          sx={{whiteSpace: 'nowrap'}}
          data-testid={`language-switch-${i18n.language || 'en-US'}`}
          onClick={() => setOpen(!open)}
        >
          {LNG_LIST_MAP[i18n.language || 'en-US']}
          {open ? <IconTriangleUp /> : <IconTriangleDown />}
        </ZmQuaternaryBtn>
      </Box>
    </Dropdown>
  );
};

export default ZmTranslationSelector;
